'use client';

import { useParams } from 'next/navigation';
import { TermsAndConditionsArabic } from '../terms-and-conditions-ar';
import { TermsAndConditionsEnglish } from '../terms-and-conditions-en';

export function TermsAndConditionsView() {
  const params = useParams();
  const { locale } = params;
  if (locale) {
    return <>{locale === 'ar' ? <TermsAndConditionsArabic /> : <TermsAndConditionsEnglish />}</>;
  }
}
